import { render, staticRenderFns } from "./mulSchemeForecast.vue?vue&type=template&id=1a844872&scoped=true"
import script from "./mulSchemeForecast.vue?vue&type=script&lang=js"
export * from "./mulSchemeForecast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a844872",
  null
  
)

export default component.exports